import React, {useEffect, useMemo, useState} from "react";
import {connect} from "react-redux";
import sortBy from "lodash/sortBy";

import PricingCheckbox from "../PricingComponents/PricingCheckbox";
import PricingPopupContext, {usePricingPopupContext} from "./PricingPopupContext";
import {toggleArrayValue} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";
import {getAllCatalogs} from "../PricingSidebar/pricingCatalogAsyncActions";


const PricingPopupAllCatalogs = (props) => {

  const {pricingPopupOpened, getAllCatalogs, pricingCatalogs} = props;
  const {pricingPopupState, pricingPopupDispatch} = usePricingPopupContext(PricingPopupContext);
  const {allCatalogsChecked} = pricingPopupState;

  const [searchInputValue, setSearchInputValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [pricingAllCatalogs, setPricingAllCatalogs] = useState([]);

  const setAllCatalogs = async () => {
    setLoading(true);
    const allCatalogs = await getAllCatalogs();
    setLoading(false);
    setPricingAllCatalogs(allCatalogs ? sortBy(allCatalogs, "id") : []);
  }

  useEffect(() => {
    if (pricingPopupOpened) {
      setAllCatalogs()
    } else if (searchInputValue) {
      setSearchInputValue("");
    }
  }, [pricingPopupOpened]);

  const displayAllCatalogs = useMemo(() => {
    if (loading) {
      return []
    }
    if (searchInputValue) {
      const lowerCasedText = searchInputValue.toLowerCase();
      return pricingAllCatalogs.filter(catalog => {
        return (catalog.newCustomName || catalog.name || "").toLowerCase().includes(lowerCasedText)
      })
    }
    return pricingAllCatalogs
  }, [loading, searchInputValue, pricingAllCatalogs]);

  if (loading) {
    return (
      <div className="pr-popup__content scrollbar3 mt-125 mb-125 pr-1 flex-item relative">
        <div className="ui-loader ui-loader--medium absolute"/>
      </div>
    )
  }

  const allChecked = displayAllCatalogs.every(catalog => {
    return allCatalogsChecked.some(cat => cat.id === catalog.id) || pricingCatalogs.some(cat => cat.id === catalog.id)
  });

  return (
    <div className="pr-popup__content scrollbar3 mt-125 mb-125 pr-1 flex-item relative">
      <input className="generic-popup-textbox radius-5 mb-05"
             type="search"
             placeholder="Search"
             onChange={(event) => setSearchInputValue(event.target.value)}
             value={searchInputValue}/>
      <div className="grid pr-grid pr-grid--light pr-grid--allCatalogs">
        <div className="pr-grid-th font--12">
          <div className="pr-grid-cell flex flex--center pl-1 pr-1 h-2">
            <PricingCheckbox id={"toggle--all"}
                             text={""}
                             className="pr-checkbox--white min-h-125 flex flex--center flex--start"
                             checked={allChecked}
                             onChange={() => pricingPopupDispatch({
                               allCatalogsChecked: allChecked
                                 ? allCatalogsChecked.filter(cat => {
                                   return !displayAllCatalogs.some(catalog => catalog.id === cat.id)
                                 })
                                 : [...allCatalogsChecked, ...displayAllCatalogs.filter(catalog => {
                                   return !pricingCatalogs.some(cat => cat.id === catalog.id)
                                     && !allCatalogsChecked.some(cat => cat.id === catalog.id)
                                 })]
                             })}/>
          </div>
          <div className="pr-grid-cell flex flex--center pl-1 pr-1 h-2 color-black3">Catalog Name</div>
        </div>
        {displayAllCatalogs.map(catalog => {
          const key = catalog.id;
          const disabled = pricingCatalogs.some(cat => cat.id === catalog.id);
          const checked = allCatalogsChecked.some(cat => cat.id === catalog.id);
          return (
            <div className="pr-grid-row mb-1" key={catalog.id}>
              <div className="pr-grid-cell font--12 color-green bold flex flex--center flex--start pl-1 pr-1">
                <PricingCheckbox id={key}
                                 text={""}
                                 className={"pr-checkbox--white min-h-125 flex flex--center flex--start" + (disabled ? " opacity-50" : "")}
                                 checked={checked || disabled}
                                 onChange={() => disabled ? null : pricingPopupDispatch({
                                   allCatalogsChecked: [...toggleArrayValue(allCatalogsChecked, catalog)]
                                 })}/>
              </div>
              <div className="pr-grid-cell font--12 flex flex--center pl-1 pr-1 text-left flex--start">
                <span className="secondary">{catalog.newCustomName || catalog.name}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingPopupOpened} = store.popups;
  const {pricingCatalogs} = store.pricingState;

  return {
    pricingPopupOpened,
    pricingCatalogs,
  };
};

const mapDispatchToProps = {
  getAllCatalogs,
}

export default (
  connect(mapStateToProps, mapDispatchToProps)(PricingPopupAllCatalogs)
)
